import Icon from '@atoms/Icon/Icon';

interface Props {
  readonly removedText: string;
  readonly handleUndoRemoval: () => void;
  readonly undoLabel: string;
}

const ItemRemovedNotification = ({
  removedText,
  handleUndoRemoval,
  undoLabel,
}: Props) => (
  <div className="flex flex-col rounded-[10px] bg-white p-5 max-md:mt-14 max-md:items-start max-md:gap-y-2.5 md:flex-row md:justify-between md:gap-x-5 md:pr-7.5">
    <div
      className="flex items-center gap-x-5"
      data-testid="CT-149-Add-To-Basket-Slide-Out-Tray-Remove-Text"
    >
      <Icon name="check_circle" colorClassName="text-green-100" />
      <span className="body-three body-three--bold">{removedText}</span>
    </div>

    <button
      className="font-normal underline max-md:pl-[44px]"
      onClick={handleUndoRemoval}
      data-testid="CT-149-Add-To-Basket-Slide-Out-Tray-Undo-Button"
    >
      {undoLabel}
    </button>
  </div>
);

export default ItemRemovedNotification;
